import APIMapper from './APIMapper';
import CampaignsController from "../../controllers/CampaignsController";

class CampaignAPIMapper extends APIMapper {
  async delete(change) {
    const { item, onSuccess, onError } = change;
    try {
      const response = await CampaignsController
        .deleteCampaign(
          item.prevValue,
        );
      onSuccess(response);
    } catch (e) {
      onError(e);
    }
  }
}

export default new CampaignAPIMapper();
